export const NAME = 'programPage';
export const ID = 'program-page';
export const SIMPLE_NAME = 'simpleProgramPage';
export const SIMPLE_ID = 'simple-program-page';
export const RECAPTCHA_SITE_KEY = '6Lfu8mIoAAAAAK4F2UBBNhcNqxyxuMMAMGJnjOqm';
